import { Reveal } from "./Reveal";
import { HiddenMouse } from "./HiddenMouse";

const quotes = [
  { q: "A funny read, full of giggles and surprises!", who: "Becky, Reuben's mum", id: "mum", c: "bg-butter rotate-[-2deg]" },
  { q: "I wish I could visit this pet shop!", who: "Maddie, Reuben's sister", id: "sister", c: "bg-mint rotate-[2deg] lg:mt-24" },
];

export const Praise = () => (
  <section id="praise" className="relative bg-cream text-ink py-28 sm:py-40">
    <HiddenMouse />
    <div className="mx-auto max-w-6xl px-5 sm:px-8">
      <Reveal><p className="text-xs sm:text-sm font-bold uppercase tracking-[0.25em] text-coral">Praise for The Party Pet Shop</p></Reveal>
      <div className="mt-12 grid lg:grid-cols-2 gap-10">
        {quotes.map((x, i) => (
          <Reveal key={x.id} delay={i * 0.15}>
            <figure data-testid={`praise-card-${x.id}`} className={`${x.c} rounded-[2rem] border-2 border-ink p-8 sm:p-12 shadow-[8px_8px_0_#12303B] hover:rotate-0 transition-transform duration-500`}>
              <span className="font-display text-7xl leading-none text-coral">“</span>
              <blockquote className="font-display text-3xl sm:text-4xl leading-tight -mt-4">{x.q}</blockquote>
              <figcaption className="mt-6 font-hand text-2xl sm:text-3xl">— {x.who}</figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
